export default {
  desktop: '@media (min-width: 992px)',
  mobile: '@media (max-width: 576px)',
  smallNavigation: '@media (max-width: 800px)',
  notNavigation: '@media (min-width: 800px)',
  tablet: '@media (min-width: 577px) and (max-width: 991px)',
  tabletOrLarger: '@media (min-width: 577px)',
  minAR8_5: `@media (min-aspect-ratio: 8/5)`,
}
